import { Component } from 'react';
import mixpanel from 'mixpanel-browser';
import { FormattedMessage, injectIntl } from 'react-intl';

// STYLES
import {
  Container,
  Relative,
  Modal,
  Header,
  Title,
  Close,
  Content,
  Label,
  Input,
  Footer,
  CancelButton,
  SaveButton,
} from 'styles/modals';

// CONSTANTS
import { ANALYTICS_EVENTS } from 'constants/mixpanel.constants';

class SaveView extends Component {
  state = {
    // @ts-expect-error TS(2339): Property 'initialViewName' does not exist on type ... Remove this comment to see the full error message
    viewName: this.props.initialViewName,
  };

  handleCloseModal = () => {
    // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (this.props.loading) {
      return;
    }

    // @ts-expect-error TS(2339): Property 'onCloseModal' does not exist on type 'Re... Remove this comment to see the full error message
    this.props.onCloseModal();
  };

  handleChangeViewName = (event) => {
    this.setState({ viewName: event.currentTarget.value });
  };

  handleSave = () => {
    // @ts-expect-error TS(2339): Property 'onSave' does not exist on type 'Readonly... Remove this comment to see the full error message
    this.props.onSave(this.state.viewName);
  };

  render() {
    return (
      <Container>
        <Relative>
          {/* @ts-expect-error TS(2769): No overload matches this call. */}
          <Modal data-testid="save-view" loading={this.props.loading}>
            <Header>
              <Title>
                <FormattedMessage id="components.Modals.SaveView.title" />
              </Title>
              <Close
                onClick={() => {
                  // @ts-expect-error TS(2339): Property 'onCloseModal' does not exist on type 'Re... Remove this comment to see the full error message
                  this.props.onCloseModal();
                  mixpanel.track(ANALYTICS_EVENTS.CLOSE_MODAL);
                }}
                className="icon-close-light"
              />
            </Header>

            <Content>
              <Label>
                <FormattedMessage id="components.Modals.SaveView.nameLabel" />
              </Label>
              <Input
                name="name"
                type="text"
                // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
                placeholder={this.props.intl.formatMessage({
                  id: 'components.Modals.SaveView.namePlaceholder',
                })}
                value={this.state.viewName}
                onChange={this.handleChangeViewName}
              />
            </Content>

            <Footer>
              {/* @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message */}
              <CancelButton onClick={this.handleCloseModal} disabled={this.props.loading} />
              {/* @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message */}
              <SaveButton onClick={this.handleSave} disabled={!this.state.viewName || this.props.loading} />
            </Footer>
          </Modal>
        </Relative>
      </Container>
    );
  }
}

// @ts-expect-error TS(2769): No overload matches this call.
export default injectIntl(SaveView);
